import React, { useState } from "react";
import {
  ModalContainer,
  SelectedPlanInfo,
  PaymentOptions,
  PaymentAnswer,
  Row,
  Input,
  LightText,
  InputWrapper,
  EmptyDiv,
  ErrorText,
  Label,
  ModalLink,
  SubtlePaymentOption,
  ChinaPaymentRow,
  //   TelegramLink,
} from "./RechargeModal.styles";
import { useSelector } from "react-redux";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import { ReactComponent as BtcSvg } from "../../assets/icons/btc.svg";
import { ReactComponent as TelegramSvg } from "../../assets/icons/telegramBlue.svg";
import { selectUser } from "../../store/slices/user/slice";
import Modal from "../utils/Modal/Modal";
import useScrollLock from "../../hooks/useScrollLock";
import Button from "../utils/Button/Button";
import { showAsianPayments } from "../../utils/utils";

const RechargeModal = ({ isOpen, onClose, handleCardPayment }) => {
  const user = useSelector(selectUser);
  const asianPaymentsEnabled = showAsianPayments(user);
  const [price, setPrice] = useState(10);
  const [paymentError, setPaymentError] = useState("");

  useScrollLock(isOpen);

  if (!isOpen) return null;

  const actionCardPayment = (paymentMethod) => {
    handleCardPayment(paymentMethod, price);
  };

  const actionRegionalPayment = (paymentMethod) => {
    const amount = Number(price);

    if (!price || amount < 2 || amount > 400) {
      setPaymentError("Payment amount must be between $2 and $400.");
      return;
    }

    setPaymentError("");
    actionCardPayment(paymentMethod);
  };

  const actionAlipayPayment = () => {
    actionRegionalPayment("ALIPAY");
  };

  const actionWechatPayment = () => {
    actionRegionalPayment("WECHAT");
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContainer>
        <Row>
          <SelectedPlanInfo>
            {user?.subscription?.name} Plan (Recharge)
          </SelectedPlanInfo>

          <CloseSvg onClick={onClose} style={{ cursor: "pointer" }} />
        </Row>

        <InputWrapper>
          <Label>Amount</Label>
          <Input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={price}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, ""); // uklanja sve što nije broj
              setPrice(value);
              setPaymentError("");
            }}
            placeholder="10"
            min={10}
          />
          {price ? (
            <LightText>
              You will receive {(user?.subscription?.topUpCredits / 10) * price}{" "}
              credits for ${price}
            </LightText>
          ) : (
            <EmptyDiv />
          )}
        </InputWrapper>

        <PaymentOptions>
          <PaymentAnswer>
            For Telegram star payment, we adhere to the principle of transparent
            pricing, and due to high channel fees, the amount you pay may be
            higher to the price we offer.
          </PaymentAnswer>
          <PaymentAnswer>
            For crypto payments, we accept top-ups of any amount, but for
            top-ups less than $10, the actual credits you receive will be
            slightly less then expected due to the fees of the payment channel.
          </PaymentAnswer>
          <PaymentAnswer>
            If you don't see the credits, please contact us via{" "}
            <ModalLink
              onClick={() => {
                window.location.href = "mailto:support@playbun.com";
              }}
            >
              email
            </ModalLink>
          </PaymentAnswer>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: "14px",
            }}
          >
            <Button
              onClick={() => {
                actionCardPayment("TELEGRAM");
              }}
              title={"Card with Telegram"}
              rightIcon={<TelegramSvg />}
              style={{ width: "100%" }}
            />

            <Button
              onClick={() => {
                actionCardPayment("CRYPTO3");
              }}
              // disabled={true}
              // title={"Crypto (Temporarily Unavailable)"}
              title={"Pay with Crypto"}
              rightIcon={<BtcSvg />}
              style={{ width: "100%" }}
            />

            {asianPaymentsEnabled && (
              <ChinaPaymentRow>
                <SubtlePaymentOption
                  type="button"
                  onClick={actionAlipayPayment}
                >
                  Pay with AliPay
                </SubtlePaymentOption>
                <SubtlePaymentOption
                  type="button"
                  onClick={actionWechatPayment}
                >
                  Pay with WeChat
                </SubtlePaymentOption>
              </ChinaPaymentRow>
            )}
            {paymentError && <ErrorText>{paymentError}</ErrorText>}

            {/* <TelegramLink
              onClick={() => {
                actionCardPayment("TELEGRAM");
              }}
            >
              Card with Telegram
            </TelegramLink> */}
          </div>
        </PaymentOptions>
      </ModalContainer>
    </Modal>
  );
};

export default RechargeModal;
